import React, { useRef, useState } from 'react';
import JiraBugReportModal, {
    JiraBugReportFormValues,
    JiraBugReportModalHandle,
} from 'components/molecules/JiraBugReportModal';
import useCreateJiraRequest from 'hooks/general/useCreateJiraRequest';
import { prepareJiraRequestPayload } from 'utils/jiraUtils';
import { BugOutlined } from '@ant-design/icons';
import { sendNotification } from 'utils/helperMethods';
import { Button, Tooltip } from 'antd';
import { colorConstants } from 'config/colorConstants';

const JiraComponent = () => {
    const { createRequest, error: errorMsg, loading } = useCreateJiraRequest();
    const [open, setOpen] = useState(false);

    const bugReportModalRef = useRef<JiraBugReportModalHandle | null>(null);

    return (
        <div>
            <JiraBugReportModal
                open={open}
                onCancel={() => setOpen(false)}
                onSubmit={async (values: JiraBugReportFormValues) => {
                    const payload = prepareJiraRequestPayload(
                        values.summary,
                        values.description,
                        values.attachments,
                        values.priority,
                    );

                    const response = await createRequest(payload);
                    if (response?.status === 'success') {
                        sendNotification(
                            'success',
                            'Jira Request Created Successfully , Please check your email for the attachments',
                        );
                        setOpen(false);
                        bugReportModalRef.current?.reset();
                    } else {
                        console.log('error: ', errorMsg);
                        sendNotification('error', 'Jira Request Creation Failed, Please try again');
                    }
                }}
                ref={bugReportModalRef}
                loading={loading}
            />

            <Tooltip
                title="Report a Bug"
                color="white"
                overlayInnerStyle={{
                    color: colorConstants.darkGrey,
                }}
            >
                <Button
                    type="default"
                    shape="circle"
                    icon={<BugOutlined style={{ fontSize: 24 }} />}
                    onClick={() => setOpen(true)}
                    style={{
                        width: 48,
                        height: 48,
                        color: '#44338a',
                        borderColor: '#44338a',
                        borderWidth: '2px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                />
            </Tooltip>
        </div>
    );
};

export default JiraComponent;
